/* eslint-disable no-param-reassign */
/* eslint-disable fp/no-mutation */
import axios from 'axios';

export const defaultHandlers = (builder, thunk, pendingKey) =>
  builder
    .addCase(thunk.pending, state => {
      state[pendingKey] = true;
      state.error = null;
    })
    .addCase(thunk.rejected, (state, {payload}) => {
      state[pendingKey] = false;
      state.error = payload.error;
    });

export const abortHandler = thunkAPI => {
  const source = axios.CancelToken.source();
  const handler = () => {
    source.cancel();
  };
  thunkAPI.signal.addEventListener('abort', handler);

  const finish = result => {
    thunkAPI.signal.removeEventListener('abort', handler);
    return result;
  };

  return [source, finish];
};
